import _Loading from "@kibt/meta-ui/es/loading";
import { defineComponent, ref, watch } from '@vue/composition-api';
import { isInApp } from '@/utils/yoda';
import { toWork } from '@/utils/ikwai';
import { commonVideoAttr } from '@/utils/dom';
import { getCdnImg } from '@/utils/cdn';
import { isIOS } from '@/utils/platform';
export default defineComponent({
  components: {
    MLoading: _Loading
  },
  props: {
    photoList: {
      type: Array,
      required: true
    }
  },
  emits: ['change-video'],
  setup: function setup(props, ctx) {
    var currentPlayId = ref('');

    var handlePhotoClick = function handlePhotoClick(photoItem) {
      if (isInApp) {
        toWork(photoItem.photo_id_str);
      } else {
        setTimeout(function () {
          // 如果是点击的是当前播放的，就置为空
          currentPlayId.value = currentPlayId.value === photoItem.photo_id_str ? '' : photoItem.photo_id_str;
        }, 300);
      }
    };

    var videoRefs = ref([]);
    var videoLoadedMap = ref({});
    watch(function () {
      return currentPlayId.value;
    }, function (curId, oldId) {
      var _videoRefs$value$oldI;

      var curIndex = props.photoList.findIndex(function (item) {
        return curId === item.photo_id_str;
      });
      var oldIndex = props.photoList.findIndex(function (item) {
        return oldId === item.photo_id_str;
      });
      (_videoRefs$value$oldI = videoRefs.value[oldIndex]) === null || _videoRefs$value$oldI === void 0 ? void 0 : _videoRefs$value$oldI.pause();
      var curPlayVideo = videoRefs.value[curIndex];

      if (curPlayVideo) {
        curPlayVideo.load();
        ctx.root.$set(videoLoadedMap.value, currentPlayId.value, false);
        curPlayVideo.addEventListener('canplay', function () {
          // console.log(videoLoadedMap.value, currentPlayId.value, true);
          ctx.root.$set(videoLoadedMap.value, currentPlayId.value, true);

          if (curId === currentPlayId.value) {
            curPlayVideo.play();
          } else {
            curPlayVideo.pause();
          }
        });
      }
    }); // 获取视频封面和视频链接

    var getPhotoOptions = function getPhotoOptions(photo) {
      var _photo$main_mv_urls_r;

      return {
        videoSrc: getCdnImg(photo.main_mv_urls_rate && ((_photo$main_mv_urls_r = photo.main_mv_urls_rate[0]) === null || _photo$main_mv_urls_r === void 0 ? void 0 : _photo$main_mv_urls_r.urls)),
        posterSrc: getCdnImg(photo.cover_thumbnail_urls),
        id: photo.photo_id_str
      };
    };

    return {
      handlePhotoClick: handlePhotoClick,
      commonVideoAttr: commonVideoAttr,
      videoRefs: videoRefs,
      currentPlayId: currentPlayId,
      getPhotoOptions: getPhotoOptions,
      videoLoadedMap: videoLoadedMap,
      isIOS: isIOS
    };
  }
});